import { Field, InputType } from 'type-graphql'
import { ViewCountKeyEnum } from '../ViewCountKeyEnum'

/**
 * Input arguments for resetting view count.
 * Used in the resetViewCount GraphQL mutation.
 */
@InputType()
export class ResetViewCountArgs {
  @Field(() => ViewCountKeyEnum, { description: 'The entity type (Order, PurchaseOrder, etc.)' })
  key: ViewCountKeyEnum

  @Field(() => String, { description: 'The entity ID' })
  value: string
}
